import Backbone from 'backbone'
import template from './upload-rollup-tree.hbs'
import FormView from 'scoreboard/components/form-view'
import _ from 'lodash'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import fileInfo from 'scoreboard/components/files/file-info'
import highlight from 'scoreboard/components/highlight'
import i18n from 'scoreboard/components/i18n'
import dropdown from 'scoreboard/components/dropdown'
import cleanObject from 'scoreboard/components/clean-object'
import { urlRoot } from './rollup-tree'
import FileDrop from 'scoreboard/components/files/file-drop'

var UploadRollupTree = Backbone.View.extend({

	tagName: 'form',

	className: 'upload-form upload-dataset-tree',

	events: {
		'click .done': 'done'
	},

	/**
	 * A form that allows a user to create a new dataset rollup tree, or replace
	 * an existing one
	 *
	 * @constructs
	 *
	 * @property {DatasetsTree} [model] an unwrapped model of an existing
	 * dataset tree to update
	 */
	initialize: function(options) {
		this.options = options || {}
		this.formView = new FormView({ el: this.el })
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this._renderFileDrop()
		this.treeLabelField = new MarkedField({
			el: this.$('[name=treeLabel]'),
			validator: requiredValidator
		}).render()
		this.renderKeySets()
		this.formView.start()
		this._attachListeners()
		return this
	},

	context: function() {
		let href = 'https://support.spiderstrategies.com/hc/en-us/articles/4408581972116-Advanced-Dataset-Rollup-Trees'
		let articleLabel = i18n.get('datasets.trees.keys.uploadJson.instructions.article')
		let article = `<a target="_blank" class="text-link" href="${href}">${articleLabel}</a>`
		let context = _.extend({
			section: highlight('datasets.trees.keys.uploadJson.instructions.section'),
			article
		}, this.model)
		return context
	},

	_attachListeners() {
		this.fileDrop.on('done', model => this.trigger('done', model))
			.on('error', xhr => this.uploadError(xhr))
			.on('start', data => this.uploadStart(data))
	},

	_renderFileDrop() {
		this.fileDrop = new FileDrop({
			animated: true,
			fileUploaderOptions: {
				url: urlRoot + '/import',
				dataFn: this.uploadData.bind(this)
			}
		})
		this.$('.dialog-body-content').append(this.fileDrop.el)
		this.fileDrop.render()
	},

	renderKeySets() {
		const {keySets} = this.model
		dropdown.idLabels(this.$('[name=keySetId]'), keySets)
		if (_.size(keySets) < 2) {
			this.$('.key-set').addClass('is-not-displayed')
		}
	},

	uploadStart: function(files) {
		// note this has to be a callback since the primaryButton isn't
		// defined yet
		this.formView.primaryButton.loading()
		// #19710 disable the cancel button
		this.$('.cancel').prop('disabled', true)

		// give the tree a name, if none was specified
		var label = this.$('[name=treeLabel]')
		if (_.isEmpty(label.val())) {
			var fileName = files[0].name
			label.val(fileInfo.fileName(fileName))
		}

		this.treeLabelField.clearError()
		this.formView.clearErrors()
	},

	uploadData: function(files) {
		return cleanObject({
			treeLabel: this.$('[name=treeLabel]').val(),
			keySetId: this.$('[name=keySetId]').val()
		})
	},

	uploadError: function(response) {
		if (response.statusText !== 'abort') {
			this.formView.error(response)
		}
		this.$('.cancel').prop('disabled', false)
		this.fileDrop.reset()
		this.treeLabelField.clearError()
	},

	close() {
		// only close the dialog if the cancel button is enabled
		if (!this.$('.cancel').prop('disabled')) {
			this.trigger('close')
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.fileDrop, this.treeLabelField], 'remove')
	}

})

export default UploadRollupTree

UploadRollupTree.__filename__ = 'admin/datasets/upload-rollup-tree.js'
